import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-menu-cliente',
  templateUrl: './menu-cliente.component.html',
  styleUrls: ['./menu-cliente.component.scss']
})
export class MenuClienteComponent implements OnInit {
  userLog:any
  xtensaBasica: boolean = true

  constructor( private loginService: LoginService) { 
    this.userLog = this.loginService.getUserData()
  }

  ngOnInit(): void {
    this.xtensaBasica = this.userLog.cliente?.xtensaBasica
  }

}
